export default "__VITE_ASSET__c72d16b8__"